<template>
    <DefaultLayout :disableFacilitatorTools="true">
      <h3>{{ $t('title')  }}</h3>
      <ScenarioSelector
        :showLocaleSelector=false
      />
      <div
        v-if="scenarioVariants.length > 0"
        class="locale-buttons-section"
      >
        <p class="locale-buttons-label">{{ $t('available-languages') }}</p>
        <div class="locale-buttons">
        <base-button
          v-for="locale in orderedContentLocales"
          :key="locale"
          size="sm"
          :type="locale === contentLocale ? 'success' : 'secondary'"
          class="locale-button"
          style="white-space: normal;"
          @click="contentLocale = locale"
        >
          <span class="locale-button__lang">{{ getLanguage(locale) }}</span>
          <span class="locale-button__title">{{ getScenarioTitle(locale) }}</span>
        </base-button>
        </div>
      </div>
      <br />
      <div v-if="selectedScenario && cases && contentLocale">
        <div v-for="aCase in getCasesInLocale" :key="aCase.case">
          <b>{{ aCase.case_number }}. {{ aCase.title }}</b><br/>
          <div v-html="aCase.description" /><br/>
          <i>{{ aCase.case_question }}</i><br/><br/>
          <div v-if="aCase.survey_question_1">Q1: {{ aCase.survey_question_1 }}</div>
          <div v-if="aCase.survey_question_2">Q2: {{ aCase.survey_question_2 }}<br/><br/></div>
          <div v-html="aCase.facilitator_instructions" /><br/>       
        </div>
      </div>
      <div v-if="selectedRPSScenario && rpsCases && contentLocale">
        <div v-for="rpsCase in getRPSCasesInLocale" :key="rpsCase.case">
          <b>{{ rpsCase.case_number }}. {{ rpsCase.title }}</b><br/>
          <div v-html="rpsCase.description" /><br/>
          <i>{{ rpsCase.case_question }}</i><br/><br/>
          <div v-if="rpsCase.description_above_cases">{{ rpsCase.description_above_cases }}<br/></div>
          <div v-for="rpsCaseChoice in getRPSCaseChoicesInLocale(rpsCase.rps_case)" :key="rpsCaseChoice.id">
            {{ rpsCaseChoice.order_number }}. <span v-html="rpsCaseChoice.choice_text" />
          </div>
          <div v-if="rpsCase.description_below_cases">{{ rpsCase.description_below_cases }}<br/><br/></div>
          <div v-html="rpsCase.facilitator_instructions" /><br/>       
        </div>
      </div>
      <base-button
            size="sm"
            type="primary"
            style="white-space: normal;margin:2px;"
            v-on:click="$router.push('/admin/games/')"
          >{{ $t('exit')  }}
      </base-button>    
    </DefaultLayout>
  </template>
  
  <script>
  import DefaultLayout from "@/layouts/DefaultLayout.vue";
  import ScenarioSelector from "@/components/ScenarioSelector.vue";
  import { getCases, getRPSCases, getRPSCaseChoices } from "@/services/APIService";
  
  export default {
    components: {
      ScenarioSelector,
      DefaultLayout,
    },
    data() {
      return {
        selectedScenario: null,
        selectedRPSScenario: null,
        cases: null,
        rpsCases: null,
        rpsCaseChoices: null,
        scenarioVariants: [],
        contentLocale: null,
      };
    },
    beforeDestroy() {
      this.$bus.$off("scenario-selector-scenario-selected");
    },
    async mounted() {
      this.$bus.$on("scenario-selector-scenario-selected", (scenario, scenarioVariants) => {
        this.scenarioSelected(scenario, scenarioVariants || []);
      });
    },
    computed: {
      orderedContentLocales() {
        return this.$store.state.main.langs.filter((lang) =>
          this.scenarioVariants.some((variant) => variant.locale === lang)
        );
      },
      getCasesInLocale() {
        return this.cases.filter(
          (aCase) => aCase.locale === this.contentLocale
        );
      },
      getRPSCasesInLocale() {
        return this.rpsCases.filter(
          (aCase) => aCase.locale === this.contentLocale
        );
      },
    },
    methods: {
      getLanguage(lang) {
        switch (lang) {
          case "en":
            return "ENGLISH";
          case "fi":
            return "SUOMI";
          case "de":
            return "DEUTSCH";
          case "sv":
            return "SVENSKA";
          case "ko":
            return "한국어";
          default:
            return lang;
        }
      },
      getScenarioTitle(locale) {
        const variant = this.scenarioVariants.find((s) => s.locale === locale);
        if (!variant) {
          return "";
        }
        return variant.short_description
          ? variant.short_description
          : variant.start_title;
      },
      getRPSCaseChoicesInLocale(rps_case) {
        return this.rpsCaseChoices.filter(
          (aCase) =>
            aCase.locale === this.contentLocale && aCase.rps_case === rps_case
        );
      },
      async scenarioSelected(scenario, scenarioVariants = []) {
        if (!scenario) {
          this.selectedScenario = null;
          this.selectedRPSScenario = null;
          this.scenarioVariants = [];
          this.contentLocale = null;
          this.cases = null;
          this.rpsCases = null;
          this.rpsCaseChoices = null;
          return;
        }

        this.scenarioVariants = scenarioVariants;
        this.contentLocale = this.$i18n.locale;

        this.selectedScenario = scenario.scenario_id;
        this.selectedRPSScenario = scenario.rps_scenario_id;
  
        if (this.selectedScenario) {
          this.rpsCases = null;
          this.rpsCaseChoices = null;
          const resp = await getCases(this.selectedScenario);
          this.cases = resp.data;
          this.cases = this.cases.sort((a, b) => {
            return a.case_number - b.case_number;
          });
        } else {
          this.cases = null;
          const resp = await getRPSCases(this.selectedRPSScenario);
          this.rpsCases = resp.data;
          this.rpsCases = this.rpsCases.sort((a, b) => {
            return a.case_number - b.case_number;
          });
          const resp2 = await getRPSCaseChoices(this.selectedRPSScenario);
          this.rpsCaseChoices = resp2.data;
          this.rpsCaseChoices = this.rpsCaseChoices.sort((a, b) => {
            return a.order_number - b.order_number;
          });
        }
      },
    },
  };
  </script>
<i18n>
  {
    "en": {
      "exit": "Exit",
      "title": "Get to know the cases of simulations",
      "available-languages": "The simulation is available in the following languages"
    },
    "fi": {
      "exit": "Poistu",
      "title": "Tutustu simulaatioiden tilanteisiin",
      "available-languages": "Simulaatio on saatavissa seuraavilla kielillä"
    },
   "sv": {
      "exit": "Avsluta",
      "title": "Lär känna fall av simuleringar",
      "available-languages": "Simuleringen är tillgänglig på följande språk"
    },
   "de": {
     "exit": "Ausgang",
      "title": "Lernen Sie die Fälle von Simulationen kennen",
      "available-languages": "Die Simulation ist in den folgenden Sprachen verfügbar"
    },
    "ko": {
      "exit": "출구",
      "title": "시뮬레이션 사례 알아보기",
      "available-languages": "시뮬레이션은 다음 언어로 제공됩니다"
      }
  }
  </i18n>

<style scoped>
.locale-buttons-section {
  margin-top: 12px;
}

.locale-buttons-label {
  margin-bottom: 8px;
  font-size: 0.875rem;
}

.locale-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.locale-buttons ::v-deep .btn {
  border-radius: 6px !important;
}

.locale-button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  max-width: 100%;
  margin-right: 0 !important;
}

.locale-button__lang {
  font-weight: 700;
  font-size: 0.75rem;
  letter-spacing: 0.02em;
}

.locale-button__title {
  font-size: 0.875rem;
  font-weight: 400;
}
</style>
